const PRODUTO_LICENCA_LABELS = {
  lifegrowth: "LifeGrowth",
  lifechat: "LifeChat"
};

export function isTruthyFlag(value) {
  return (
    value === true ||
    value === "t" ||
    value === "true" ||
    value === 1 ||
    value === "1"
  );
}

export function isModuleLicensable(row) {
  return isTruthyFlag(row && row.module_licensable);
}

export function precoExibidoModulo(row) {
  if (!row) {
    return null;
  }
  if (
    row.module_total_price !== undefined &&
    row.module_total_price !== null &&
    row.module_total_price !== ""
  ) {
    return row.module_total_price;
  }
  return row.module_price;
}

export function hasLicencasPanel(licencas) {
  return Array.isArray(licencas) && licencas.length > 0;
}

export function labelProdutoLicenca(produto) {
  if (produto === null || produto === undefined || produto === "") {
    return "";
  }
  const key = String(produto).toLowerCase();
  return PRODUTO_LICENCA_LABELS[key] || String(produto);
}

export function formatUsuariosAtivos(value) {
  if (value === null || value === undefined) {
    return "Indisponível";
  }
  return String(value);
}

export function isUsuariosAtivosIndisponivel(value) {
  return value === null || value === undefined;
}

export function normalizeLicencasFromApi(licencas) {
  return Array.isArray(licencas) ? licencas : [];
}

export function formatCompetenciaLabel(competencia) {
  if (!competencia) {
    return "";
  }
  const parts = String(competencia).split("-");
  if (parts.length >= 2) {
    return `${parts[1]}/${parts[0]}`;
  }
  return String(competencia);
}
